const SESSION_TOKEN_KEY = 'qr_session_token';
const REFRESH_TOKEN_KEY = 'qr_refresh_token';
const SESSION_EXPIRES_KEY = 'qr_session_expires';

export const tokenStorage = {
  getSessionToken(): string | null {
    return sessionStorage.getItem(SESSION_TOKEN_KEY);
  },

  getRefreshToken(): string | null {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
  },

  getSessionExpiry(): string | null {
    return sessionStorage.getItem(SESSION_EXPIRES_KEY);
  },

  save(sessionToken: string, refreshToken: string, expiresAt?: string): void {
    sessionStorage.setItem(SESSION_TOKEN_KEY, sessionToken);
    sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    if (expiresAt !== undefined) {
      sessionStorage.setItem(SESSION_EXPIRES_KEY, expiresAt);
    }
  },

  clear(): void {
    sessionStorage.removeItem(SESSION_TOKEN_KEY);
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
    sessionStorage.removeItem(SESSION_EXPIRES_KEY);
  },

  isExpired(): boolean {
    const expiry = sessionStorage.getItem(SESSION_EXPIRES_KEY);
    if (expiry === null) return true;
    return Date.now() >= new Date(expiry).getTime();
  },
};
